import { Grid } from '@chakra-ui/react';
import { isFunction } from '@waitroom/utils';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import ShareLink from '../../FormControl/ShareLink/ShareLink';
import ShareLinks from '../../Link/ShareLinks/ShareLinks';
import Modal, { ModalProps } from '../Modal';

const buttonStyles = {
  size: 'md',
  fontSize: '4xl',
};

export interface ShareModalProps extends Omit<ModalProps, 'children'> {
  url?: string;
  showSocialLinks?: boolean;
  children?: React.ReactNode | ((url: string) => React.ReactNode | null);
}

const ShareModal = ({
  url = window.location.href,
  children,
  isOpen,
  showSocialLinks = true,
  ...rest
}: ShareModalProps): React.ReactElement | null => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen && !!url} {...rest}>
      <Modal.Header>{t('global.shareSession')}</Modal.Header>
      <Modal.Body>
        {showSocialLinks && (
          <Grid
            templateColumns="repeat(auto-fit, minmax(60px, 1fr))"
            gap={{ base: 2, md: 4, lg: 6 }}
            mt={6}
            mb={8}
            textAlign="center"
            flexWrap="wrap"
          >
            <ShareLinks url={url} iconButtonProps={buttonStyles} showName />
          </Grid>
        )}
        <div>
          <ShareLink link={url} buttonText={t('global.copy')} size="def" />
        </div>
        {isFunction(children) ? children(url) : children}
      </Modal.Body>
    </Modal>
  );
};

export default ShareModal;
